/**
 * Основная навигация. Пункты, для которых ещё нет страниц, добавлять сюда
 * только вместе с маршрутом в App.js — битых ссылок быть не должно.
 */
export const mainNav = [
  { to: '/', label: 'Главная', end: true },
  { to: '/projects', label: 'Проекты' },
];
